import { FunctionComponent, useEffect, useState } from "react";
import "../../pages/organization/receipts/nota-fiscal.scss";
import { UploadIcon } from "lucide-react";
import ModalUploadExcel from "../modal/modal-upload-excel/modal-upload-excel";
import { useAppDispatch, useAppSelector } from "../../features/helpers";
import { fetchOrders } from "../../store/ReceiptsSlice";
import { tryGetOrgId } from "../../store/orgHelpers";
import { ItemListResponse } from "../../models/Receipts";

import { DataList, DataListColumn, StatusBadge } from "../ui";

const ReceiptsOrders: FunctionComponent = () => {

    const orders: ItemListResponse | null = useAppSelector((s) => s.receipts.listOrders);
    const orgId                           = useAppSelector(tryGetOrgId);

    const dispatch = useAppDispatch();
    const [showUploadModal, setShowUploadModal] = useState(false);

    useEffect(() => {
        if (orgId) dispatch(fetchOrders(orgId));
    }, [dispatch, orgId]);

    const handleUploadSuccess = () => setShowUploadModal(false);

    const columns: DataListColumn<any>[] = [
        { key: "n",       header: "#",                width: "60px",  render: (_, i) => i + 1, mono: true },
        { key: "numero",  header: "Numero da Ordem",  render: (o) => o.numero, mono: true },
        { key: "data",    header: "Data Envio",       render: (o) => <span style={{ opacity: .55 }}>{o.dataEnvio}</span>, mono: true },
        { key: "qty",     header: "Quantidade",       render: (o) => o.quantidade, align: "right", mono: true },
        { key: "status",  header: "Status",           render: (o) => <StatusBadge status={o.status} /> },
    ];

    return (
        <>
            <div className="tab-ordens">
                <div className="actions-bar" style={{ marginBottom: 18 }}>
                    <button className="btn-pill primary" onClick={() => setShowUploadModal(true)}>
                        <UploadIcon size={14} /> Enviar Excel
                    </button>
                </div>

                <DataList
                    columns={columns}
                    rows={orders?.data ?? []}
                    loading={!orders}
                    empty="Nenhuma ordem enviada."
                />
            </div>

            {showUploadModal && (
                <ModalUploadExcel
                    onClose={() => setShowUploadModal(false)}
                    onSuccess={handleUploadSuccess}
                />
            )}
        </>
    );
};

export default ReceiptsOrders;
